import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { TriangleIcon } from "@icons";
import classNames from "classnames";
import styles from "./MapImportedAccountsSpreadsheet.module.scss";

interface Props {
    classification: AccountClass;
    count: number;
    isExpanded: boolean;
    onToggle: () => void;
}

export const ClassificationSectionHeader: React.FC<Props> = ({
    classification,
    count,
    isExpanded,
    onToggle,
}) => (
    <div className={styles.classificationHeader}>
        <button
            type="button"
            className={styles.classificationToggle}
            onClick={onToggle}
            aria-expanded={isExpanded}
        >
            <TriangleIcon
                className={classNames(
                    "icon-color-gray-500",
                    styles.classificationToggleIcon,
                    {
                        [styles.collapsed]: !isExpanded,
                    },
                )}
            />
            <span className={styles.classificationLabel}>{classification}</span>
            <span className={styles.classificationCount}>{count}</span>
        </button>
    </div>
);
